import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ConditionalExpr } from '@angular/compiler';
import { PraService } from "../../services/pra.service";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { first } from "rxjs/operators";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions, } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../services/authentication.service";
//lodash
import * as _ from 'lodash';

@Component({
  selector: 'child-cell',
  template: `<span><button style="height: 15px; font-size:12px; padding:2px 5px 2px 5px" (click)="invokeParentMethod()" class="btn-custom btn btn-primary">Details</button></span>&nbsp;
    <span *ngIf="submitted && admin"><button style="height: 15px; font-size:12px; padding:2px 5px 2px 5px" (click)="invokeCompleteMethod(completeModal)" class="btn-custom btn btn-primary">Complete</button></span>

    <!-- ***************** START Complete Details Grid Modal ******************** -->
<ng-template #completeModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Complete Request #{{params.data.PRARequestID}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
  <label for="changeDate">Upload document (optional)<br>
      <span style="font-size: 12px; font-weight: normal;">Multiple documents accepted</span></label>
    <div class="form-group">
      <input #fileUploader style="display: none;" class="form-control" type="file" id="file"
        (change)="getFileDetails($event)">
      <input class="btn btn-default" type="button" value="Browse..."
        onclick="document.getElementById('file').click();" />
      <br>
      <span *ngIf="showFileLimit" style="color:#d1282e">
              <br>
              <div class="alert alert-danger" role="alert" style="font-size: 14px;">
                The file you just chose can not be added because the file name can not be more than 50 characters long. Please modify the length of the file name and try
                again.
              </div>
            </span>
            <span *ngIf="showFileSizeLimit" style="color:#d1282e">
              <br>
              <div class="alert alert-danger" role="alert" style="font-size: 14px;">
                The file you just chose can not be added because the file can not be more than 2 Mb.
              </div>
            </span>
            <span *ngIf="showFileSizeMultipleLimit" style="color:#d1282e">
              <br>
              <div class="alert alert-danger" role="alert" style="font-size: 14px;">
                The file you just chose can not be added because the total size of your file(s) are more than 2 Mb.
              </div>
            </span>
      <br>
      <table class="table table-bordered" style="width: 100%;" *ngIf="myFiles.length > 0">
              <tbody>
                <tr *ngFor="let y of myFiles; let i = index">
                  <td style="width:250px; text-align: left; padding:14px 0 0 8px; color:#666">
                    <p>{{y.name}}</p>
                  </td>
                  <td style="text-align: right; padding:14px 18px 0 8px; color:#666">
                    <p>{{y.size / 1000000 | number:'1.2-2'}} Mb</p>
                  </td>
                  <td style="text-align: right; padding:14xpx 8px 0 0">
                    <span>
                      <a style="cursor: pointer" (click)="removeFile(i); fileUploader.value = null">
                        <fa-icon [icon]="['fas', 'times']" class="red-icon"></fa-icon> Remove
                      </a>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: right; margin-bottom: 0; padding:14px 18px 0 8px; color:#000">
                    <p><strong>Total file Size: </strong>{{totalFileSize / 1000000 | number:'1.2-2'}} Mb</p>
                  </td>
                  <td>
                  </td>
                </tr>
              </tbody>
            </table>
    </div>
    Are you sure you would like to complete and finalize this request?
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="d()">Go Back</button>
    <span *ngIf="loading">
                  <img src="assets/images/preloader_panda_small.gif" style="height:35px; width:35px" />
                </span>
    <button type="button" class="btn btn-primary" (click)="uploadFiles(confirmCompleteAlert)">Complete
      Request</button>
  </div>
</ng-template>
<!-- ***************** END Complete Details Grid Modal ******************** -->


<!-- ***************** START Confirm Complete Modal ******************** -->
<ng-template #confirmCompleteAlert let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Request Confirmation</h4>
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <fa-icon [icon]="['fas', 'check-circle']" class="icon"></fa-icon> &nbsp;The request has been completed successfully.
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="d()">Close</button>&nbsp;&nbsp;
  </div>
</ng-template>
<!-- ***************** END Confirm Complete Modal ******************** -->

    `,
  styles: [
    `.btn-custom {
            line-height: 0.5
        }
        .red-icon {
          font-size: 16px;
          color: #d1282e;
          text-align: center;
        }
        .icon {
          font-size: 20px;
          color: #1eb600;
          text-align: center;
      }
        `
  ]
})
export class ChildRequestGridComponent implements ICellRendererAngularComp {
  loading: boolean = false;

  public params: any;
  public submitted: boolean = false;
  public admin: boolean = false;
  currentUser: any;
  //Modals
  modalOption: NgbModalOptions = {};
  modalCancel: NgbModalRef;
  modalCancelConfirm: NgbModalRef;
  modalComplete: NgbModalRef;
  modalCompleteConfirm: NgbModalRef;
  modalDoc: NgbModalRef;
  closeResult: string;
  totalFileSize: number;
  showFileLimit: boolean = false;
  showFileSizeLimit: boolean = false;
  showFileSizeMultipleLimit: boolean = false;

  //Upload Files
  myFiles: string[] = [];
  @ViewChild('fileUploader') fileUploader:ElementRef;

  constructor(
    private praService: PraService,
    private router: Router,
    private modalService: NgbModal,
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService
  ) { }


  agInit(params: any): void {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.params = params;

    if (this.params.data.RequestStatusCode == "Submitted") {
      this.submitted = true;
    }
    if (this.currentUser.payrolladmin || this.currentUser.payrollsuperadmin ) {
      this.admin = true;
    }
  }

  invokeParentMethod() {
    this.params.context.componentParent.methodFromParent(
      this.params.data.PRARequestID
    );
  }

  invokeCompleteMethod(modal) {
    this.myFiles = [];
    this.modalComplete = this.modalService.open(modal);
    console.log(this.modalComplete);
    this.modalComplete.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    console.log(this.modalComplete)
  }

  getFileDetails(e) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;

    console.log(e);
    console.log(e.target.files);
    console.log(`Total size: ${_.sumBy(e.target.files, 'size')}`);
    console.log(this.myFiles);
    for (var i = 0; i < e.target.files.length; i++) {
      let currentTotal = _.sumBy(this.myFiles, 'size') + e.target.files[i].size
      //get current file size total
      console.log(currentTotal);
      //Don't allow file names greater than 50 characters
      if (e.target.files[i].name.length > 50) {
        console.log("File character too long")
        this.showFileLimit = true;
      } else if (currentTotal > 2000000) {
        this.showFileSizeMultipleLimit = true;
      } else if (e.target.files[i].name.size > 2000000) {
        this.showFileSizeLimit = true;
      } else {
        this.myFiles.push(e.target.files[i]);
        this.showFileLimit = false;
        this.showFileSizeLimit = false;
        this.showFileSizeMultipleLimit = false;
      }

    }
    console.log(this.myFiles);
    console.log(`Total my files: ${_.sumBy(this.myFiles, 'size')}`);
    this.totalFileSize = _.sumBy(this.myFiles, 'size');
  }

  removeFile(index) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    //remove file from list
    const removeFile = this.myFiles
    removeFile.splice(index, 1);
    this.myFiles = removeFile
    console.log(this.myFiles);
    //recalculate total file size
    this.totalFileSize = _.sumBy(this.myFiles, 'size');
  }

  uploadFiles(modal) {
    this.loading = true;
    this.params.context.componentParent.activateLoading();

    const frmData = new FormData();

    for (var i = 0; i < this.myFiles.length; i++) {
      frmData.append("uploadDocument", this.myFiles[i]);
    }
    console.log(frmData)

    this.httpClient.post<any>(`${environment.serverUrl}/api/Data/UploadDocuments?RequestID=${this.params.data.PRARequestID}&SubjectEid=${this.params.data.EmployeeID}&AuditEid=${this.currentUser.employeeId}`, frmData
    ).subscribe(
      data => {
        //Proceed complete
        this.completePRARequest(modal);


        // SHOW A MESSAGE RECEIVED FROM THE WEB API.
        console.log(data);

      },
      (error) => {
        this.loading = false;
        console.log(error.message);    // Show error, if any.
        this.authenticationService.logout();
        this.router.navigate(["/login"]);
      }
    );
  }

  completePRARequest(modal) {
    this.loading = true;
    const result = this.praService
      .completePRARequest(this.params.data.PRARequestID, this.currentUser.employeeId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          console.log(data);
          if (data.isSuccess == true) {
            console.log("success!");
            this.modalComplete.close();
            this.modalCompleteConfirm = this.modalService.open(
              modal,
              this.modalOption
            );
            this.modalCompleteConfirm.result.then(
              (result) => {
                this.closeResult = `Closed with: ${result}`;
              },
              (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
            );
            this.params.context.componentParent.completeMethodCompleted();
          } else {
            if (data.ErrMessage) {
              console.log(data.ErrMessage);
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          }
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  refresh(): boolean {
    return false;
  }

}
